import { render } from "./HelpBar.vue?vue&type=template&id=3f597268&scoped=true"
import script from "./HelpBar.vue?vue&type=script&lang=js"
export * from "./HelpBar.vue?vue&type=script&lang=js"

import "./HelpBar.vue?vue&type=style&index=0&id=3f597268&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f597268"]])

export default __exports__